<template>
  <div style="position: relative;">
    <swiper :options="swiperOption" ref="mySwiper" style="height: 200px;">
      <!-- slides -->
      <swiper-slide
        v-for="(attachement, index) in attachementList || [{}]"
        :key="index"
        class="d-flex align-center justify-center"
      >
        <v-img
          :src="apiURL + 'archive/' + (attachement.archive || []).id"
          contain
          max-height="200"
        />
        <v-btn
          icon
          top
          right
          color="red"
          absolute
          @click="removeItem(index)"
          v-if="editable"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </swiper-slide>

      <swiper-slide v-if="attachementList && attachementList.length == 0">
        <div
          style="height: 200px; background:white color:black"
          class="d-flex flex-column align-center justify-center"
        >
          <div>
            <v-img :src="cp_logo" contain height="70"></v-img>
          </div>
          <p class="mt-2 body-2 font-weight-medium primary--text">
            Galería sin imágenes
          </p>
        </div>
      </swiper-slide>

      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
      <!--         <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>-->
      <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
    </swiper>
    <v-btn
      color="secondary"
      @click="$refs.file.click()"
      fab
      small
      dark
      absolute
      bottom
      right
      v-if="editable"
    >
      <SvgIcon icon="cp-camera" fill="white" height="20px"></SvgIcon>
    </v-btn>
    <input
      hidden
      ref="file"
      type="file"
      accept="image/*"
      @change="addItem"
      multiple
    />

    <v-snackbar v-model="snackMessage" bottom left color="success">
      {{ snackMessageText }}
    </v-snackbar>
  </div>
</template>

<script>
import api from "../../api.js";
import SvgIcon from "@/components/SvgIcon";

export default {
  props: ["organismId", "occurrenceId", "editable"],
  components: { SvgIcon },
  data: () => ({
    apiURL: api.baseURL,
    cp_logo: require("@/assets/logo.png"),
    attachementList: [],
    snackMessage: false,
    snackMessageText: "",
    swiperOption: {
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    }
  }),
  methods: {
    showAttachment: function() {
      this.dialogAttachment = true;
    },
    async addItem() {
      try {
        this.snackMessageText = "Subiendo imágenes";
        this.snackMessage = true;

        let files = this.$refs.file.files || [];
        this.$refs.file.files = null;

        for (let file of files) {
          let formData = new FormData();
          formData.append("fileupload", file);
          let { data: archiveCreated } = await this.$http.post(
            "archive",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          );

          if (this.organismId) {
            let { data: attachementCreated } = await this.$http.post(
              "attachement",
              {
                archive: archiveCreated.id,
                organism: this.organismId,
                occurrence: this.occurrenceId,
                type: "organismProfile"
              }
            );
            this.attachementList = [
              ...this.attachementList,
              ...[
                {
                  ...(attachementCreated || {}),
                  archive: archiveCreated
                }
              ]
            ];
          } else {
            this.attachementList.push({
              archive: archiveCreated
            });
          }
        }

        this.snackMessageText = "Archivos cargados exitosamente";
        this.snackMessage = true;

        this.$emit("update:attachementList", this.attachementList);
      } catch (err) {
        console.log(err);
        this.snackMessageText = "Ha ocurrido un error";
        this.snackMessage = true;
      }
    },
    async removeItem(index) {
      let [removed] = this.attachementList.splice(index, 1);
      if (removed && removed.id) {
        await this.$http.patch("attachement/" + removed.id, { deleted: true });
      }
      this.$emit("update:attachementList", this.attachementList);
    }
  },
  async mounted() {
    try {
      if (this.organismId) {
        let { data: attachementList } = await this.$http.get("attachement", {
          params: {
            where: {
              type: "organismProfile",
              organism: this.organismId,
              occurrence: this.occurrenceId,
              deleted: false
            }
          }
        });
        this.attachementList = attachementList || [];
      }
    } catch (err) {
      console.log(err);
    }
  },
  watch: {
    attachementList() {
      this.$emit("lengthUpdated", (this.attachementList || []).length);
    }
  }
};
</script>

<style>
.swiper-slide {
  width: 100% !important;
  height: auto;
}
.picture-img {
  max-width: 100%;
  max-height: 100%;
}
.swiper-pagination-bullet-active {
  background: white !important;
}

.swiper-pagination-bullet {
  background: whitesmoke !important;
}
</style>
